var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.826,
    height: 22.606,
    viewBox: "0 0 16.826 22.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(-9312.259 -6454.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-document",
    "data-name": "Icon ionic-ios-document",
    transform: "translate(9312.759 6457.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M15.233,7.825V3.938H8.867A1.56,1.56,0,0,0,7.313,5.492V21.82a1.56,1.56,0,0,0,1.555,1.555H20.53a1.56,1.56,0,0,0,1.555-1.555V10.012H17.42A2.19,2.19,0,0,1,15.233,7.825Z",
    transform: "translate(-7.313 -3.938)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-clock",
    "data-name": "Icon feather-clock",
    transform: "translate(9320.184 6455.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M11.4,7.2A4.2,4.2,0,1,1,7.2,3,4.2,4.2,0,0,1,11.4,7.2Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M18,9v2.52l1.68.84",
    transform: "translate(-13.799 -7.32)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.46b57844d0263f26ec6e4a8055d828c5.svg";
export { ForwardRef as ReactComponent };